import React, { useState, useEffect } from 'react';
import './ConnectionsPuzzle.css';

const WORDS = [
  // Row 1
  "[B]lack","[C]lue","[D]irty","Co[u]ntry","Hik[a]ru","[P]amela","B[o]","Le[v]on",
  // Row 2
  "S[a]y","Lif[e]","Do[w]nward","R[a]sp","Ky[l]a","Su[n]ny","Checker[s]","Fio[n]a",
  // Row 3
  "[G]oose","T[o]p","Gov[e]rnment","[B]lue","Ch[u]ck","Re[x]","Darry[l]","[R]iva",
  // Row 4
  "Trou[b]le","Condi[t]ion","R[i]sk","[H]ot","Ha[l]le","Ga[r]ry","Ju[d]it","[C]amila",
  // Row 5
  "Juic[e]","Fried C[h]icken","Turno[v]er","Fritt[e]r","Machin[e]","Thim[b]le","Impe[a]ch","of th[e] Art",
  // Row 6
  "[A]vocados","Th[e] Nuts","[P]ie","[R]oll","Days of Su[m]mer","Iro[n]","[P]lump","Fla[g]",
  // Row 7
  "[C]hips","C[h]ocolate","Gr[a]pes","Str[i]p","Pear[l]","[F]air","Ho[r]se","S[e]date",
  // Row 8
  "P[o]t","Fi[s]h","O[n]ions","[T]oast","Tire[d]","[S]cottish Terrier","Pi[l]e","Hous[e]"
];

const LOGICAL_COLS = 8;
const DEFAULT_COLORS = ['#fff8b5', '#cfe9ff', '#ffd6e8', '#d7ffd9'];

function bracketToBoldAllCaps(s) {
  let html = s.replace(/\[(.+?)\]/g, (_, inner) => `§§§${inner}§§§`);
  html = html.replace(/\[|\]/g, "");
  html = html.toUpperCase().replace(/§§§(.*?)§§§/g, "<strong>$1</strong>");
  return html;
}

function ConnectionsPuzzle() {
  const [cellColors, setCellColors] = useState({});
  const [activeColor, setActiveColor] = useState(DEFAULT_COLORS[0]);

  useEffect(() => {
    const savedColors = {};
    WORDS.forEach((_, idx) => {
      const saved = localStorage.getItem(`connections.cell.${idx}`);
      if (saved) {
        savedColors[idx] = saved;
      }
    });
    setCellColors(savedColors);
  }, []);

  const setCellColor = (idx, color) => {
    setCellColors(prev => {
      const newColors = { ...prev };
      if (color) {
        newColors[idx] = color;
      } else {
        delete newColors[idx];
      }
      return newColors;
    });
    localStorage.setItem(`connections.cell.${idx}`, color || '');
  };

  const handleCellClick = (idx, e) => {
    const target = e.currentTarget;
    if (e.shiftKey) {
      setCellColor(idx, '');
      target.blur();
      return;
    }
    const current = cellColors[idx] || '';
    if (current && current.toLowerCase() === activeColor.toLowerCase()) {
      setCellColor(idx, '');
      target.blur();
    } else {
      setCellColor(idx, activeColor);
    }
  };

  const handleColorSelect = (color) => {
    setActiveColor(color);
  };

  const getGridPosition = (idx) => {
    const r = Math.floor(idx / LOGICAL_COLS);
    const c = idx % LOGICAL_COLS;
    const gridRow = r < 4 ? r + 1 : r + 2;
    const gridCol = c < 4 ? c + 1 : c + 2;
    return { gridRow, gridCol };
  };

  return (
    <div className="connections-puzzle">
      <div className="connections-grid">
        <div className="divider vertical" aria-hidden="true" />
        <div className="divider horizontal" aria-hidden="true" />
        
        {WORDS.map((word, idx) => {
          const { gridRow, gridCol } = getGridPosition(idx);
          return (
            <div
              key={idx}
              className="connections-cell"
              style={{
                gridRow,
                gridColumn: gridCol,
                backgroundColor: cellColors[idx] || ''
              }}
              onClick={(e) => handleCellClick(idx, e)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleCellClick(idx, e);
                } else if (e.key === 'Backspace' || e.key === 'Delete') {
                  e.preventDefault();
                  setCellColor(idx, '');
                }
              }}
              dangerouslySetInnerHTML={{ __html: bracketToBoldAllCaps(word) }}
            />
          );
        })}
      </div>

      <div className="connections-controls">
        <div className="swatches">
          {DEFAULT_COLORS.map((color, idx) => (
            <button
              key={idx}
              className={`swatch ${activeColor === color ? 'active' : ''}`}
              style={{ backgroundColor: color }}
              onClick={() => handleColorSelect(color)}
              aria-label={`Select color ${idx + 1}`}
            />
          ))}
        </div>
        <div className="hint">
          Click a color, then click cells to paint. Click again to clear.
          Shift-click always clears.
          <span 
            className="active-indicator" 
            style={{ backgroundColor: activeColor }}
          />
        </div>
      </div>
    </div>
  );
}

export default ConnectionsPuzzle;
